module.exports = __webpack_public_path__ + "frontend/images/gold/ultimate/bg@2.jpg?9d9ddc21b1f3d1d5f5790596bee4e29d";